export default "/_next/static/chunks/fonts/Roboto-ThinItalic-latin-67afe351b211e4e455546a9e54ba0424.woff2";